export const Supplies = {
    problems: {
        version: ['e1'],
        timepoint: ['*'],
    },
};
